import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client'
import typeDefs from '../gql/typeDefs'
import Config from '../config'

const GQL_LINK = Config.GQL_LINK

class GqlClient {

  constructor () {

  }

  updateToken (token) {
    localStorage.setItem('token', token)
  }

  removeToken () {
    localStorage.removeItem('token')
  }

  async query ({ query, variables = {} }) {
    return new Promise(resolve => {
      this.Request.query({
        query,
        ...(Boolean(variables) && { variables })
      })
        .then(({ data, networkStatus}) => {
          resolve({ success: true, data })
        })
        .catch(() => resolve({ success: false }))
    })
  }

  async mutation ({ mutation, variables = {} }) {
    return new Promise(resolve => {
      this.Request.mutate({
        mutation,
        ...(Boolean(variables) && { variables })
      })
        .then(({ data, networkStatus}) => {
          resolve({ success: true, data })
        })
        .catch(() => resolve({ success: false }))
    })
  }

  get Request () {
    const token = localStorage.getItem('token')

    const authLink = setContext((_, { headers }) => {
      return {
        headers: {
          ...headers,
          ...(Boolean(token) && { authorization: 'Bearer '+ token }),
        }
      }
    })

    const errorLink = onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          )
        );
      if (networkError) console.log(`[Network error]: ${networkError}`);
    })

    const httpLink = new HttpLink({
      uri: GQL_LINK
    })

    return new ApolloClient({
      link: ApolloLink.from([ errorLink, authLink, httpLink ]),
      cache: new InMemoryCache(),
      typeDefs
    })
  }
}

export default new GqlClient()
